const menus = [
    {
        id: 1,
        tomenu: "#about",
        namemenu: "About me"
    },
    {
        id: 2,
        tomenu: "#services",
        namemenu: "Degrees and expertise"
    },
    {
        id: 3,
        tomenu: "#portfolio",
        namemenu: "Portafolio"
    },
    // {
    //     id: 4,
    //     tomenu: "#testimonial",
    //     namemenu: "Testimonial"
    // },
    {
        id: 5,
        tomenu: "#resume",
        namemenu: "CV"
    },
];



export default menus ;